import api from '@/utils/api';

export default {
  getAllPermission: ({ token }) => api.get('/permission', { headers: { Authorization: `Bearer ${token}` } }),
};
